import { InvestorRightEnumType } from '__generated__/graphql';

export const investorRightOptions = [
  { value: InvestorRightEnumType.None, label: 'None' },
  {
    value: InvestorRightEnumType.TagAlongRights,
    label: 'Tag-along rights on founder transfers',
  },
  { value: InvestorRightEnumType.AntiDilutionProtection, label: 'Anti-dilution protection' },
  { value: InvestorRightEnumType.LiquidationPreference, label: 'Liquidation preference' },
  { value: InvestorRightEnumType.PreEmptionRights, label: 'Pre-emption rights' },
  { value: InvestorRightEnumType.InformationRights, label: 'Information rights' },
  {
    value: InvestorRightEnumType.ExitRightsParticipation,
    label: 'Exit rights (right to participate in an exit)',
  },
  {
    value: InvestorRightEnumType.ExitRightsControl,
    label: 'Exit rights (rights to control an exit event)',
  },
  {
    value: InvestorRightEnumType.FreeTransferability,
    label: 'Free transferability of shares',
  },
  { value: InvestorRightEnumType.AffirmativeVoteRights, label: 'Affirmative vote rights' },
  { value: InvestorRightEnumType.BoardSeat, label: 'Board seat' },
  { value: InvestorRightEnumType.RofoRofr, label: 'ROFO/ROFR' },
];
